import React, { Component } from "react";
import { connect } from "react-redux";
import CustomSelect from "../../components/common/select/Select";
import ChannelMiddleware from "../../store/prat_middleware/gt/channelMiddleware";
import "./style/productDetail.scss";
import { openDB } from 'idb';
import IsChannel from './validation/channelSection'

let channelDataRes=[]
let isSaveDraft = false
let channelFlags = []
let productData=[];
class ChannelDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedChannel: [],
      selectedMasterChannel: [],
      selectedElement: [],
      selectedSubElement: [],
      myMasterChannel:[],
      myChannel:[],
      myElement:[],
      mySubElement:[],
      sync:false,
      evein:false,
      isExtend:true,
      selectedAllMasterChannelFlag:null,
      selectedAllChannelFlag:null,
      selectedAllElementFlag:null,
      selectedAllSubElementFlag:null,
      mtPromoCheck:[]
    };
  }
  firstTimeData(channel,element,sub_element){
    isSaveDraft=true
    const getData = async  () => {
if (!("indexedDB" in window)) {
    console.warn("IndexedDB not supported");
    return;
  }
  const dbName = "gt_form";
  const storeName = "product_store";
  const version = 1; //versions start at 1

    const db = await openDB(dbName, version, {
    
  });
            let result = await db
            .transaction(storeName)
            .objectStore(storeName)
            .get("channel_detail");

            let getChannelFlags = await db
            .transaction(storeName)
            .objectStore(storeName)
            .get("selectedAllChannelFlags");

            let productRes = await db
            .transaction(storeName)
            .objectStore(storeName)
            .get("product_detail");

            channelDataRes=result ? result.value : []
            channelFlags = getChannelFlags ? getChannelFlags.value : []
            productData=productRes ? productRes.value : []

      channelDataRes=channelDataRes[0] ? channelDataRes[0] : channelDataRes
      channelFlags = channelFlags[0] ? channelFlags[0] : channelFlags
      productData=productData[0]?productData[0]:productData

      if(productData.length!==0 ){
        if(productData.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){     //when promo type is MT
          let masterChannelSelect = ['261ae803-0149-4083-9127-da216a08da83'];
          let channelSelect = ['728b7ffd-b505-4309-81a6-50fa0fcd53ce'];
          let elementSelect = ['9d92f1a7-f7ce-46b6-be89-3dd28edc1452'];
          let subElementSelect = ['79602414-df4e-439a-bd82-048b641d958a'];
          let masterChannelArr = [{
            Code: "CN0001",
            CustomCode: "a95145bb-37ac-4257-9108-c57ed421988c",
            IsActive: true,
            Name: "MT",
            guid: "261ae803-0149-4083-9127-da216a08da83"
          }]
          let channelArr = [{
            Code: "CN2002",
            CustomCode: "cfd5747a-d1e4-43ac-abd3-62576e021ad1",
            IsActive: true,
            MasterChannel: "261ae803-0149-4083-9127-da216a08da83",
            Name: "Supermarket",
            guid: "728b7ffd-b505-4309-81a6-50fa0fcd53ce"
          }]
          let elementArr = [{
            Channel: "728b7ffd-b505-4309-81a6-50fa0fcd53ce",
            Code: "CN3002",
            CustomCode: "d8513661-0a44-4aca-a5e4-529cc0a53dac",
            IsActive: true,
            Name: "LMT",
            guid: "9d92f1a7-f7ce-46b6-be89-3dd28edc1452"
          }]
          let subElementArr = [{
            Code: "C11664",
            CustomCode: "e971dc28-5514-41b8-ae32-71851e73085c",
            Element: "9d92f1a7-f7ce-46b6-be89-3dd28edc1452",
            IsActive: true,
            Name: "Supermarket LMT (Non-Direct)",
            guid: "79602414-df4e-439a-bd82-048b641d958a"
          }]
          this.setState({
          selectedMasterChannel:masterChannelSelect,
          myMasterChannel:masterChannelArr,
          selectedAllMasterChannelFlag:false,

          selectedChannel: channelDataRes?.channels?.length === 1 && channelDataRes?.channels.includes('728b7ffd-b505-4309-81a6-50fa0fcd53ce') ? channelDataRes?.channels : channelSelect,
          myChannel: channelArr,
          selectedAllChannelFlag: false,

          selectedElement: channelDataRes?.elements?.length === 1 && channelDataRes?.elements.includes('9d92f1a7-f7ce-46b6-be89-3dd28edc1452') ? channelDataRes?.elements : elementSelect,
          myElement: elementArr,
          selectedAllElementFlag: false,

          selectedSubElement: channelDataRes?.sub_elements?.length === 1 && channelDataRes?.sub_elements.includes('79602414-df4e-439a-bd82-048b641d958a') ? channelDataRes?.sub_elements : subElementSelect,
          mySubElement: subElementArr,
          selectedAllSubElementFlag: false,
        })
        }
        else{
          let masterChannelWithoutMT = this.props?.master_channel && this.props?.master_channel.filter(item=> item.guid !== '261ae803-0149-4083-9127-da216a08da83')
          this.setState({myMasterChannel:masterChannelWithoutMT,selectedMasterChannel:[],selectedAllMasterChannelFlag:null})
        }
      }

      if(channelDataRes.length!==0){
          isSaveDraft=true
          if (channelDataRes.master_channels && channel && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9') {
            let filteredChannel = [];
          // alert("hekko");
          for (let i = 0; i < channelDataRes.master_channels.length; i++) {
            filteredChannel.push(
              ...channel.filter(item => {   // eslint-disable-line
                return item.MasterChannel === channelDataRes.master_channels[i];
              })
            );
          }    
          this.setState({myChannel:filteredChannel})
        }
        
        if (channelDataRes.channels && element && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9') {
          let filteredElement=[]
          for (let i = 0; i < channelDataRes.channels.length; i++) {
            filteredElement.push(
              ...element.filter(item => {     // eslint-disable-line
                return item.Channel === channelDataRes.channels[i];
              })
            );
          }    
          this.setState({myElement:filteredElement})
        }
  
        if (channelDataRes.elements && sub_element && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9') {
          let filteredSubElement=[]
          for (let i = 0; i < channelDataRes.elements.length; i++) {
            filteredSubElement.push(
              ...sub_element.filter(item => {       // eslint-disable-line
                return item.Element === channelDataRes.elements[i];
              })
            );
          }    
          this.setState({mySubElement:filteredSubElement})
        }
        if(channelDataRes.master_channels && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedMasterChannel:channelDataRes.master_channels})
        }
        if(channelDataRes.channels && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedChannel:channelDataRes.channels})
        }
        if(channelDataRes.elements && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedElement:channelDataRes.elements})
        }
        if(channelDataRes.sub_elements && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedSubElement:channelDataRes.sub_elements})
        }

        if((channelFlags.master_channels === true || channelFlags.master_channels === false || channelFlags.master_channels == null) && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedAllMasterChannelFlag:channelFlags.master_channels})
        }
        if((channelFlags.channels === true || channelFlags.channels === false || channelFlags.channels == null) && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedAllChannelFlag:channelFlags.channels})
        }
        if((channelFlags.elements === true || channelFlags.elements === false || channelFlags.elements == null) && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedAllElementFlag:channelFlags.elements})
        }
        if((channelFlags.sub_elements === true || channelFlags.sub_elements === false || channelFlags.sub_elements == null) && productData.promotion_type !== '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9'){
          this.setState({selectedAllSubElementFlag:channelFlags.sub_elements})
        }
        isSaveDraft=true        
      }
  }
  
    getData() ;   
    isSaveDraft=true
  }
  componentDidMount() {
    const {
      get_channel,get_elements,get_masterChannel,get_subElements,channel,element,sub_element} = this.props;
    get_channel();
    get_masterChannel(this.props.currentForm);
    get_elements();
    get_subElements();
      
    this.firstTimeData(channel,element,sub_element)
   
  }

  handleMasterChannelChange=(selectedMasterChannel)=>{

    let duplicateArray = Array.isArray(selectedMasterChannel) ? selectedMasterChannel : [selectedMasterChannel]
     let arr = [];
     if( duplicateArray == null || duplicateArray.length===0 ){
      this.setState({selectedMasterChannel:[], myChannel:[],myElement:[],mySubElement:[] ,selectedChannel:[],selectedElement:[],selectedSubElement:[] },
       () => {
        IsChannel.ischannel('onEmpty')
        this.setState({
          selectedAllMasterChannelFlag: null,
          selectedAllChannelFlag: null,
          selectedAllElementFlag: null,
          selectedAllSubElementFlag: null
        })      
       } )
    }
     if(duplicateArray){
      duplicateArray.forEach(element => {
         arr.push(element.value);              
     });
     this.setState({selectedMasterChannel:arr}, () => {
       IsChannel.ischannel('master_channel',this.state,this.props)         
       this.handleFilteredChannel();      
        this.setState({
          selectedAllMasterChannelFlag: this.state.selectedMasterChannel.length === 0 ? null : this.state.myMasterChannel?.length === this.state.selectedMasterChannel.length ? true :false,
          selectedAllChannelFlag: this.state.selectedChannel.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.myChannel?.length === (this.state.selectedChannel.length+1) ? true :false :this.state.myChannel?.length === this.state.selectedChannel.length ? true :false,
          selectedAllElementFlag: this.state.selectedElement.length === 0 ? null : this.state.myElement?.length === this.state.selectedElement.length ? true :false,
          selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.mySubElement?.length === (this.state.selectedSubElement.length+1) ? true : false : this.state.mySubElement?.length === this.state.selectedSubElement.length ? true : false
        })
     } )
 }
 
 }

 handleFilteredChannel(){
    const {
        selectedMasterChannel,
        selectedChannel,
        myChannel
      } = this.state;
      const { channel } = this.props;
      let filteredChannel = [];
      if (selectedMasterChannel.length !== 0 && channel) {
        for (let i = 0; i < selectedMasterChannel.length; i++) {
          filteredChannel.push(
            ...channel.filter(item => {
              return item.MasterChannel === selectedMasterChannel[i];
            })
          );
        }
  
        let selectedChannelFinal = [];
        myChannel.forEach(element => {
          if (selectedChannel.length !== 0) {
            selectedChannel.forEach(e => {
              if (element.guid === e) {
                filteredChannel.length!==0 &&
                filteredChannel.forEach((filtered_mskus) => {
                 if(filtered_mskus.guid === e){
                  selectedChannelFinal.push(e);
                this.setState({
                  selectedChannel: selectedChannelFinal
                });
                 } 
                })
                
              }
            });
          }
        });
  
        this.setState({
          myChannel: filteredChannel
        }, () => {
          this.handleFilteredElement()
          this.setState({
            selectedAllChannelFlag: this.state.selectedChannel.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.myChannel?.length === (this.state.selectedChannel.length+1) ? true :false :this.state.myChannel?.length === this.state.selectedChannel.length ? true :false,
            selectedAllElementFlag: this.state.selectedElement.length === 0 ? null : this.state.myElement?.length === this.state.selectedElement.length ? true :false,
            selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.mySubElement?.length === (this.state.selectedSubElement.length+1) ? true : false : this.state.mySubElement?.length === this.state.selectedSubElement.length ? true : false
          })
        });
      
      }

 
 }

 handleChannelChange=(selectedChannel)=>{
   let arr = [];
    if( selectedChannel == null || selectedChannel.length===0  ){
    this.setState({selectedChannel:[],selectedElement:[],selectedSubElement:[],myElement:[],mySubElement:[] },() => {
      IsChannel.ischannel('onEmpty') 
      this.setState({
        selectedAllChannelFlag: null,
        selectedAllElementFlag: null,
        selectedAllSubElementFlag: null
      })        
    })
 }
    if(selectedChannel){
    selectedChannel.forEach(element => {
        arr.push(element.value);            
    });
    this.setState({selectedChannel:arr}, () => {
      IsChannel.ischannel('channel',this.state,this.props)         
      this.handleFilteredElement();
      this.setState({
        selectedAllChannelFlag: this.state.selectedChannel.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.myChannel?.length === (this.state.selectedChannel.length+1) ? true :false :this.state.myChannel?.length === this.state.selectedChannel.length ? true :false,
        selectedAllElementFlag: this.state.selectedElement.length === 0 ? null : this.state.myElement?.length === this.state.selectedElement.length ? true :false,
        selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.mySubElement?.length === (this.state.selectedSubElement.length+1) ? true : false : this.state.mySubElement?.length === this.state.selectedSubElement.length ? true : false
      })
    } )
  }
}

handleFilteredElement(){
  const {
      selectedChannel,
      selectedElement,
      myElement
    } = this.state;
    const { element } = this.props;
 
    let filteredElement = [];
    if (selectedChannel.length !== 0 && element) {
      for (let i = 0; i < selectedChannel.length; i++) {
        filteredElement.push(
          ...element.filter(item => {
            return item.Channel === selectedChannel[i];
          })
        );
      }

      let selectedTownFinal = [];
      myElement.forEach(element => {
        
        if (selectedElement.length !== 0) {
          selectedElement.forEach(e => {
            if (element.guid === e) {
              filteredElement.length!==0 &&
              filteredElement.forEach((filtered_elem) => {
                if(filtered_elem.guid === e){
                selectedTownFinal.push(e);
                this.setState({
                  selectedElement: selectedTownFinal
                }  );                                             
              }
              })
             
            }
          });
        }
      });

      this.setState({
        myElement: filteredElement
      },() => {
        this.handleFilteredSubElement()
        this.setState({
          selectedAllElementFlag: this.state.selectedElement.length === 0 ? null : this.state.myElement?.length === this.state.selectedElement.length ? true :false,
          selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.mySubElement?.length === (this.state.selectedSubElement.length+1) ? true : false : this.state.mySubElement?.length === this.state.selectedSubElement.length ? true : false
        })
      });     
    }    
}

handleElementChange=(selectedElement)=>{
   let arr = [];
    if( selectedElement == null || selectedElement.length===0  ){
    this.setState({selectedElement:[],selectedSubElement:[],mySubElement:[] },() => {
      IsChannel.ischannel('onEmpty')
      this.setState({
        selectedAllElementFlag: null,
        selectedAllSubElementFlag: null
      })       
    })
 }
   if(selectedElement){
   selectedElement.forEach(element => {
       arr.push(element.value);            
   });
   this.setState({selectedElement:arr}, () => {
     IsChannel.ischannel('element',this.state,this.props)
     this.handleFilteredSubElement();
     this.setState({
      selectedAllElementFlag: this.state.selectedElement.length === 0 ? null : this.state.myElement?.length === this.state.selectedElement.length ? true :false,
      selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.mySubElement?.length === (this.state.selectedSubElement.length+1) ? true : false : this.state.mySubElement?.length === this.state.selectedSubElement.length ? true : false
    })     
   } )
}

}

handleFilteredSubElement(){
    const { sub_element } = this.props;
    let filteredSubElement = [];
      if (this.state.selectedElement.length !== 0 && sub_element) {
        for (let i = 0; i < this.state.selectedElement.length; i++) {
          filteredSubElement.push(
            ...sub_element.filter(item => {
              return item.Element === this.state.selectedElement[i];
            })
          );
        }
  
        let selectedSubElementFinal = [];
        this.state.mySubElement.forEach(element => {
          if (this.state.selectedSubElement.length !== 0) {
            this.state.selectedSubElement.forEach(e => {
              if (element.guid === e) {
                filteredSubElement.length!==0 &&
                filteredSubElement.forEach((filtered_elem) => {
                  if(filtered_elem.guid === e){
                selectedSubElementFinal.push(e);
                // localStorage.setItem('brands', selectedProductBrandsFinal)
                this.setState({
                  selectedSubElement: selectedSubElementFinal
                });
              }})
              }else {
              }
            });
          }
        });
        this.setState({
          mySubElement: filteredSubElement
        },()=>{
          this.setState({
            selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? this.state.mySubElement?.length === (this.state.selectedSubElement.length+1) ? true : false : this.state.mySubElement?.length === this.state.selectedSubElement.length ? true : false
          })
        });
      }
      
}

handleSubElementChange=(selectedSubElement)=>{
   let arr = [];
    if( selectedSubElement == null || selectedSubElement.length===0 ){
    this.setState({selectedSubElement:[] }, () => {
      IsChannel.ischannel('onEmpty')
      this.setState({
        selectedAllSubElementFlag: null
      })       
    })
 } if(selectedSubElement){
   selectedSubElement.forEach(element => {
       arr.push(element.value);            
   });
   this.setState({selectedSubElement:arr},() => {
    IsChannel.ischannel('sub_element',this.state,this.props);
    this.setState({
      selectedAllSubElementFlag: this.state.selectedSubElement.length === 0 ? null : this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ? (this.state.mySubElement?.length === (this.state.selectedSubElement.length+1)) ? true : false : (this.state.mySubElement?.length === this.state.selectedSubElement.length) ? true : false
    }) 
   })
}

}


channelData(data,flag,for_newPromotion){
  const saveData = async  (data,flag) => {
    if (!("indexedDB" in window)) {
        console.warn("IndexedDB not supported");
        return;
      }
      const dbName = "gt_form";
      const storeName = "product_store";
      const version = 1; //versions start at 1

       const db = await openDB(dbName, version, {
        upgrade(db, oldVersion, newVersion, transaction) {
          const store = db.createObjectStore(storeName);      // eslint-disable-line
        }
      });
      const tx = await db.transaction(storeName, "readwrite");
      const store = await tx.objectStore(storeName); 
          let draft=undefined;
          if(!for_newPromotion){      
            const value = await store.put({"key":"channel_123","value":data },"channel_detail");      // eslint-disable-line
            const isSave = await store.put({"key":"draft_123","value":flag},"is_draft_saved")         // eslint-disable-line

        await tx.dones;                
          let resp; let txs;let obj;  
          resp  =   await db
          txs  = await resp.transaction(storeName)
          obj= await txs.objectStore(storeName)
          let channelDataResult = await obj.get('channel_detail');
          draft = await obj.get('is_draft_saved');  
          channelDataRes=channelDataResult ? channelDataResult.value : []
          draft=draft ? draft.value : void 0
           } else{
            const isNewPromotion = await store.put({ "key": "is_newPromotion", "value": for_newPromotion },     // eslint-disable-line
             "is_newPromotion")        
    
          }
          this.props.call_back(this.props.draft_state===true?true:isSaveDraft===true?false: draft)    
      }
      if(isSaveDraft===false){
        saveData(data,flag)
      }
      else{
        isSaveDraft=false
      }
}

setFlagDataInDb(data){
   
  const saveFlagData = async (data) => {
    if (!("indexedDB" in window)) {
      console.warn("IndexedDB not supported");
      return;
    }

    const dbName = "gt_form";
    const storeName = "product_store";
    const version = 1; //versions start at 1

    const db = await openDB(dbName, version, {
      upgrade(db, oldVersion, newVersion, transaction) {
        const store = db.createObjectStore(storeName);    // eslint-disable-line
      }
    });
    const tx = await db.transaction(storeName, "readwrite");
    const store = await tx.objectStore(storeName);     
    let value = undefined;      // eslint-disable-line
      value = await store.put({ "key": "sele_cha_123", "value": data }, "selectedAllChannelFlags");
      await tx.dones; 
  }

  saveFlagData(data)

}

getChannelData(){
    const getData = async  () => {
      if (!("indexedDB" in window)) {
          console.warn("IndexedDB not supported");
          return;
        }
        const dbName = "gt_form";
        const storeName = "product_store";
        const version = 1; //versions start at 1
  
         const db = await openDB(dbName, version, {
          
        });
          let result =   await db
                  .transaction(storeName)
                  .objectStore(storeName)
                  .get("channel_detail");
      
                 channelDataRes=result ? result.value : []

        }
  
        getData() ;          
}

   componentDidUpdate(prevProps, PrevState) {
        const {
      selectedChannel,    
      selectedSubElement,
      selectedMasterChannel,
      selectedElement
    } = this.state;
    isSaveDraft=false
   if((this.state!==PrevState)){
     if(isSaveDraft===false){
    let statedata = [{
      master_channels:selectedMasterChannel,
      channels:selectedChannel,
      elements:selectedElement,
      sub_elements:selectedSubElement}];

      // For Creating select all flags
      let flagArray = [
        {
          master_channels: this.state.selectedMasterChannel.length === 0 ? null : this.state.selectedAllMasterChannelFlag,
          channels: this.state.selectedChannel.length === 0 ? null : this.state.selectedAllChannelFlag,
          elements: this.state.selectedElement.length === 0 ? null : this.state.selectedAllElementFlag,
          sub_elements: this.state.selectedSubElement.length === 0 ? null : this.state.selectedAllSubElementFlag,
        }
      ]
      this.channelData(statedata,true)
      this.setFlagDataInDb(flagArray);
    }
    else{
      isSaveDraft= false
    }
   }   

   if((prevProps.channel!==this.props.channel)||(prevProps.element!==this.props.element)||
   (prevProps.sub_element!==this.props.sub_element)){
    const {channel,element,sub_element} = this.props
   this.firstTimeData(channel,element,sub_element)
 }
  }

  render(props) {
    const {
      selectedChannel,    
      selectedSubElement,
      selectedMasterChannel,
      selectedElement,myElement,myChannel,mySubElement
    } = this.state;
    const { channel, master_channel, element, sub_element } = this.props;
    let statedata = [{
      master_channels:selectedMasterChannel,
      channels:selectedChannel,
      elements:selectedElement,
      sub_elements:selectedSubElement}];
    this.props.counter!==2 ? this.channelData(statedata,this.props.draft_state) : void 0;
    (this.props.counter===2 && this.state.sync===true) || channelDataRes.length!==0 ? this.getChannelData() : void 0
    return (
      <>
        <div  >
          <div className="product_detail">
            <p>Channel Detail</p>
          </div>

          <div
            style={(style.label, { paddingTop: "3vh", paddingBottom: "1vh" })}
          >
            <label for="prom">Master Channel <span className='mandatory_fields' >
              *
              </span> </label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={this.props.draftData?.IsExtended === true || productData.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9' ? true : false}
            placeholder={ master_channel ?  "Master Channel" : "Loading..."}
            allowSelectAll={this.props.isInvoiceOn ? true : false}
            isMulti={this.props.isInvoiceOn ? true : false}
            options={
              this.state.myMasterChannel
                ? this.state.myMasterChannel.map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
                : []
            }
            value={ 
               this.state.myMasterChannel
              ? this.state.myMasterChannel
              .filter(item => {
                      return !selectedMasterChannel?void 0 : selectedMasterChannel.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : []           
            }
            onChange={this.handleMasterChannelChange}
          />

          <div style={style.label}>
            <label for="prom">Channel</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={!this.props.isInvoiceOn || this.props.draftData?.IsExtended === true || productData.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9' ? true : false}
            placeholder={ channel ?  "Channel" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              myChannel
                ? myChannel
                .filter((sub_elem) => {
                  return (this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ?
                  sub_elem.guid !== "fa525ca3-b680-4dfc-ba47-bac82b5a07d9" : 
                  sub_elem.guid  ) 
                   
                })
                .map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={  myChannel
              ? myChannel
                  .filter(item => {                   
                      return !selectedChannel?void 0 : selectedChannel.includes( item.guid ) ;
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null}
           onChange={this.handleChannelChange}
          />

          <div style={style.label}>
            <label for="prom">Element</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={!this.props.isInvoiceOn || this.props.draftData?.IsExtended === true || productData.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9' ? true : false}
            placeholder={ element ?  "Element" : "Loading..."}
            allowSelectAll={true}
            isMulti
            options={
              myElement
                ? myElement.map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={  
               myElement
              ? myElement
                  .filter(item => {
                      return !selectedElement?void 0 : selectedElement.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null}
            onChange={this.handleElementChange}
          />

          <div style={style.label}>
            <label for="prom">Sub-Element</label>
          </div>

          <CustomSelect.MyCustomSelect
            isDisabled={!this.props.isInvoiceOn || this.props.draftData?.IsExtended === true || productData.promotion_type === '5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9' ? true : false}
            placeholder={ sub_element ?  "Sub-Element" : "Loading..." }
            allowSelectAll={true}
            isMulti
            options={
              mySubElement 
                ? mySubElement
                .filter((sub_elem) => {
                 
                  return (this.state.selectedMasterChannel.includes('261ae803-0149-4083-9127-da216a08da83') === true ?
                  sub_elem.guid !== "4731bddf-bb8a-405c-91e1-1f7e20711d6e" : 
                  sub_elem.guid  )
                })
                .map(item => ({
                    value: item.guid,
                    label: item.Name
                  }))
                : []
            }
            value={  mySubElement
              ? mySubElement
                  .filter(item => {
                      return !selectedSubElement?void 0 : selectedSubElement.includes(
                      item.guid
                      );
                  })
                  .map(item => {
                      return {
                      value: item.guid,
                      label: item.Name
                      };
                  })
              : null}
          onChange={this.handleSubElementChange}
          />
        </div>
      </>
    );
  }
}

const style = {
  label: {
    paddingBottom: "1vh",
    paddingTop: "5.5vh",
    fontFamily: "'Source Sans Pro', sans-serif",
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.25,
    letterSpacing: "normal",
    textAlign: "left",
    color: "#202126"
  }
};

// redux

const mapStateToProps = state => {
  return {
    channel: state.GtChannelReducer.channel,
    master_channel: state.GtChannelReducer.masterChannel,
    element: state.GtChannelReducer.element,
    sub_element: state.GtChannelReducer.subElement,
    draftData: state.CreatePromotionReducer.draftData,

  };
};

const mapDispatchToProps = dispatch => {
  return {
    get_masterChannel: (currentForm) => {
      return dispatch(ChannelMiddleware.get_masterChannel(currentForm));
    },
    get_channel: () => {
      return dispatch(ChannelMiddleware.get_channel());
    },
    get_elements: () => {
      return dispatch(ChannelMiddleware.get_elements());
    },
    get_subElements: () => {
      return dispatch(ChannelMiddleware.get_subElements());
    },

  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ChannelDetail);
